export interface ParentContract {
  id: number;
  is_active: boolean;
}
